/**
 * Vantage Core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Insurance carrier information returned when retrieving all insurance carriers
 */
export interface InsuranceCarrierIntegrationViewModel {
  /**
   * Dataset Id
   */
  datasetId?: string;
  /**
   * Insurance Carrier code, max length 50
   */
  carrierCode?: string | null;
  /**
   * Insurance Carrier Name, max length 100
   */
  carrierName?: string | null;
  /**
   * Insurance Carrier Address Line 1, max length 100
   */
  address1?: string | null;
  /**
   * Insurance Carrier Address Line 2, max length 100
   */
  address2?: string | null;
  /**
   * Insurance Carrier City, max length 50
   */
  city?: string | null;
  /**
   * Insurance Carrier State Code, must be a valid US state code
   */
  stateCode?: string | null;
  /**
   * Insurance Carrier Zipcode, max length 20
   */
  zip?: string | null;
  /**
   * Insurance Carrier Phone Number, max length 20
   */
  phoneNumber?: string | null;
  /**
   * Insurance Carrier country code, max length 20
   */
  countryCode?: string | null;
  /**
   * Phicure PayerId for electronic claims, max length 50
   */
  payerId?: string | null;
  /**
   * Financial class code for insurance carrier, max length 4
   */
  financialClassCode?: string | null;
  /**
   * Financial class name for insurance carrier, max length 100
   */
  financialClassName?: string | null;
}
